import { AwesomePhoneNumberService } from './AwesomePhonenumberService';

export default AwesomePhoneNumberService;
